import { render, staticRenderFns } from "./collector-allocate.vue?vue&type=template&id=e85db00c&scoped=true"
import script from "./collector-allocate.vue?vue&type=script&lang=ts"
export * from "./collector-allocate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85db00c",
  null
  
)

export default component.exports